{
  "refinement.locale.calendar.unscheduled": "saatsiz",
  "refinement.locale.calendar.unscheduledDate": "{{date}} · saatsiz",
  "refinement.locale.calendar.timeRetained": "mevcut saat korundu",
  "refinement.locale.calendar.keepTime": "saat korunacak",
  "refinement.locale.history.timezone": "Saat dilimi",
  "refinement.locale.history.date": "Tarih",
  "refinement.locale.history.occurred": "Gerçekleşme",
  "refinement.locale.history.start": "Başlangıç",
  "refinement.locale.history.end": "Bitiş",
  "refinement.locale.history.channel": "Kanal",
  "refinement.locale.history.source": "Kaynak",
  "refinement.locale.validation.required": "{{field}} zorunludur.",
  "refinement.locale.validation.maxLength": "{{field}} en fazla {{maximum}} karakter olabilir.",
  "refinement.locale.validation.invalidField": "Bu alanın değerini kontrol edin.",
  "refinement.locale.error.code": "Hata kodu: {{code}}",
  "refinement.locale.filters.active_one": " · {{count}} etkin",
  "refinement.locale.filters.active_other": " · {{count}} etkin",
  "refinement.locale.archive.span": "{{kind}} · Katman {{lane}} · {{range}}",
  "refinement.locale.dates.from": "{{date}} tarihinden itibaren",
  "refinement.locale.dates.until": "{{date}} tarihine kadar",
  "refinement.locale.dates.ends": "{{date}} tarihinde biter",
  "refinement.locale.routine.cancelled": "iptal edildi",
  "refinement.locale.routine.pending": "bekliyor",
  "refinement.locale.year.completed_one": "{{count}} tamamlanan",
  "refinement.locale.year.completed_other": "{{count}} tamamlanan",
  "refinement.locale.year.focus_one": "{{count}} dakika odak",
  "refinement.locale.year.focus_other": "{{count}} dakika odak",
  "refinement.locale.energy.matches": "enerjine uygun",
  "refinement.locale.energy.lighter": "enerjinden hafif",
  "refinement.locale.field.defaultUnit": "adet",
  "refinement.life.day.actions": "{{title}} için diğer işlemler",
  "refinement.life.dock.windows_one": "{{count}} küçültülmüş pencere",
  "refinement.life.dock.windows_other": "{{count}} küçültülmüş pencere",
  "refinement.locale.task.hidden": "gizli",
  "refinement.locale.date.placeholder": "GG.AA.YYYY",
  "refinement.workdesk.focus.state.closed": "Odak hazır",
  "refinement.workdesk.focus.state.open": "Odak açık",
  "refinement.workdesk.focus.state.minimized": "Odak küçültüldü",
  "refinement.workdesk.focus.restore": "Odağa dön",
  "refinement.locale.time.hourAbbrev": "sa",
  "refinement.locale.count.block_one": "blok",
  "refinement.locale.count.block_other": "blok",
  "refinement.locale.color.indigo": "Çivit",
  "refinement.locale.color.teal": "Camgöbeği",
  "refinement.locale.color.amber": "Kehribar",
  "refinement.locale.color.rose": "Gül",
  "refinement.locale.color.violet": "Menekşe",
  "refinement.locale.color.emerald": "Zümrüt",
  "refinement.locale.color.sky": "Gökyüzü",
  "refinement.locale.color.clay": "Kil",
  "refinement.locale.color.slate": "Arduvaz",
  "refinement.locale.color.plum": "Erik"
}
